import { createSlice } from "@reduxjs/toolkit"
import { initialFilterTable } from "../../component/atoms/Tabel"

const initState = {
  pageData: [],
  page: initialFilterTable,
  combobox: [],
  data: undefined,
  actions: false
}

export const AreaMapSlice = createSlice({
  name: "areamap",
  initialState: initState,
  reducers: {
    getPage: (state, action) => {
      state.data = action.payload
    },
    setCombobox: (state, action) => {
      state.combobox = action.payload
    },
    setPageData: (state, action) => {
      const { pageData, page } = action.payload
      state.pageData = pageData
      state.page = page
    },
    setActions: (state, action) => {
      state.actions = action.payload
    }
  }
})
